import { useTableInstanceContext } from "@/providers/PlanningTabularProvider";
import { appstr } from "@coreapp/utils/appstr";
import { TooltipWrapper } from "@theorgchartdev/storybook";
import { ComponentProps, useMemo } from "react";

export const useToolbarButtonTooltip = (
  action: "edit" | "clone" | "reopen" | "close" | "release" | "unassign",
  customMessage?: string
): ComponentProps<typeof TooltipWrapper>["tooltipProps"] => {
  const {
    selectedPositionsCount,
    isOnlyClosedPositionsSelected,
    isClosedOrUnassignedPositionsSelected,
    isOnlyActivePositionsSelected
  } = useTableInstanceContext();

  return useMemo(() => {
    const tooltipProps: ComponentProps<typeof TooltipWrapper>["tooltipProps"] = {
      position: "top-start"
    };
    if (customMessage) {
      return { ...tooltipProps, message: customMessage };
    }

    let message;
    const noPositionSelected = selectedPositionsCount === 0;
    const multiplePositionsSelected = selectedPositionsCount > 1;
    const onlyClosedPositionsSelected = isOnlyClosedPositionsSelected();
    const closedOrUnassignedPositionsSelected = isClosedOrUnassignedPositionsSelected();
    const onlyActivePositionsSelected = isOnlyActivePositionsSelected();

    if (noPositionSelected) {
      message = appstr("noPositionSelectedTooltipInfo");
    }
    switch (action) {
      case "reopen":
        if (onlyActivePositionsSelected) {
          message = appstr("onlyActivePositionsSelectedTooltipInfo");
        }
        break;
      case "edit":
        if (onlyClosedPositionsSelected) {
          message = appstr("onlyClosedPositionsSelectedTooltipInfo");
        }
        break;
      case "clone":
        if (multiplePositionsSelected) {
          message = appstr("multiplePositionsSelectedTooltipInfo");
        }
        if (onlyClosedPositionsSelected) {
          message = appstr("onlyClosedPositionsSelectedTooltipInfo");
        }
        break;
      case "close":
        if (onlyClosedPositionsSelected) {
          message = appstr("onlyClosedPositionsSelectedTooltipInfo");
        }
        break;
      case "release":
      case "unassign":
        if (closedOrUnassignedPositionsSelected) {
          message = appstr("closedOrUnassignedPositionsSelectedTooltipInfo");
        }
        if (onlyClosedPositionsSelected) {
          message = appstr("onlyClosedPositionsSelectedTooltipInfo");
        }
        break;
      default:
        message = undefined;
        break;
    }

    return message ? { message, position: "top-start" } : undefined;
  }, [
    customMessage,
    action,
    selectedPositionsCount,
    isOnlyClosedPositionsSelected,
    isClosedOrUnassignedPositionsSelected,
    isOnlyActivePositionsSelected
  ]);
};
